import { FormState, FormValidationFunction } from '@Shared/Components/Forms/FormElement.types'
import { TextInputValidationFn } from '@Shared/Components/Inputs/TextInput/TextInput'

export const MaxLengthValidation: (length: number) => FormValidationFunction<unknown> = length => (value, t) => {
  if (`${value}`.length <= length) {
    return { state: FormState.VALID }
  }
  return {
    message: t('checkout:MAX_X_CHARACTERS', { arg1: length }),
    state: FormState.ERROR,
  }
}
export const MaxLengthValidationV2: (length: number, t) => TextInputValidationFn = (length, t) => (value) => {
  if (`${value}`.length <= length) {
    return { success: true, errorMessage: '' }
  }
  return {
    errorMessage: t('checkout:MAX_X_CHARACTERS', { arg1: length }),
    success: false,
  }
}

export const getAddressMaxLength: (storeId) => number = (storeId) => {
  switch (storeId) {
    case '10': // FR
    case '21': // IE
      return 40
    case '24': // PT
      return 45
    case '8': // UK
      return 35
    default:
      return 50
  }
}
